// B2BES [AST-359] - ADD Customization - Part of AST-359 EVO Payments
import { PayInvoicePageContext } from "@auer-steel/Pages/PayInvoicePage";
import { Wallet } from "@auer-steel/Services/AuerSteelApiModels";
import { getWalletsList } from "@auer-steel/Services/WalletService";
import { AuerState } from "@auer-steel/Store/AuerState";
import loadAchWallets from "@auer-steel/Store/Pages/PayInvoice/Handlers/LoadAchWallets";
import updateInvoicePayments from "@auer-steel/Store/Pages/PayInvoice/Handlers/UpdateInvoicePayments";
import { ACHWalletsDropdown } from "@auer-steel/Widgets/Common/PayfabricWallet/ACHWalletsDropdown";
import { CreateWallet } from "@auer-steel/Widgets/Common/PayfabricWallet/CreateWallet";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface ACHWalletStyles {
    container?: GridContainerProps;
    fullWidthGridItem?: GridItemProps;
    achAccountsEmptyErrorText?: any;
    createWalletSection?: InjectableCss;
}

const mapStateToProps = (state: AuerState) => ({
    invoicePaymentCollection: state.payInvoice.invoicePaymentCollection,
    walletsAreLoading: state.payInvoice.walletsAreLoading,
    selectedWalletId: state.payInvoice.invoicePaymentCollection.achAccountId,
    wallets: state.payInvoice.wallets
});

const mapDispatchToProps = {
    updateInvoicePayments,
    loadAchWallets,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const styles: ACHWalletStyles = {
    container: {
        gap: 0,
        offsetCss: css`
            flex-direction: column;
        `,
    },
    fullWidthGridItem: {
        width: 12
    },
    achAccountsEmptyErrorText: {
        color: "#CD2037",
        weight: 600,
    },
    createWalletSection: {
        css: css`
            margin: 5px 0;
            `,
    }
}

export const ACHWalletSelection: React.FC<Props> = (props) => {
    const { wallets, walletsAreLoading } = props;
    const [createModalIsOpen, setCreateModalIsOpen] = React.useState(false);
    const createModalOpenHandler = () => {
        setCreateModalIsOpen(true);
    };

    const handleAchAccountChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedWallet = wallets.find(({ PaymentProfileId }) => PaymentProfileId === e.target.value);
        props.updateInvoicePayments({
            ...props.invoicePaymentCollection,
            achAccountId: e.target.value,
            paymentInformation: {
                routingNumber: selectedWallet!.CardType,
                bankAccountType: selectedWallet!.Address1,
                bankName: selectedWallet!.Address2,
                accountNumber: e.target.value
            },
        });
    };

    const createModalCloseHandler = () => {
        setCreateModalIsOpen(false);     
        props.loadAchWallets({});
    };

    return (
        <GridContainer {...styles.container}>
            {walletsAreLoading && (
                <LoadingSpinner></LoadingSpinner>
            )}
            {(!wallets || wallets.length < 1) && (
                <div>
                    <GridItem {...styles.fullWidthGridItem}>
                        <Typography {...styles.achAccountsEmptyErrorText}>
                            {translate("ACH Account needed to proceed")}
                        </Typography>
                    </GridItem>
                </div>
                
            )}
            {!walletsAreLoading && wallets && wallets.length > 0 && (
                <>
                    <GridItem {...styles.fullWidthGridItem}>
                        <ACHWalletsDropdown wallets={wallets} walletChangeHandler={handleAchAccountChange} error={false} />
                    </GridItem>
                </>
            )}
            <StyledWrapper {...styles.createWalletSection}>
                <Link onClick={createModalOpenHandler} style={{marginTop: 10}}>{translate("Create New ACH Account")}</Link>
                    <Modal
                    headline={translate("Create ACH Account")}
                    isOpen={createModalIsOpen}
                    handleClose={createModalCloseHandler}
                >
                    <CreateWallet modalCloseHandler={createModalCloseHandler}/>
                </Modal>
            </StyledWrapper>
            
        </GridContainer >
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ACHWalletSelection),
    definition: {
        group: "Pay Invoice" as any,
        allowedContexts: [PayInvoicePageContext],
    },
};

export default widgetModule;
